/* 🤖 this file was generated by svg-to-ts */
export const siriusSquareHalfHorisontal: {
  name: 'square_half_horisontal';
  data: string;
} = {
  name: 'square_half_horisontal',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.875 3.375a1.5 1.5 0 0 0-1.5 1.5v14.25a1.5 1.5 0 0 0 1.5 1.5h14.25a1.5 1.5 0 0 0 1.5-1.5V4.875a1.5 1.5 0 0 0-1.5-1.5H4.875Zm14.25 7.875V4.875H4.875v6.375h14.25Zm-14.25 1.5h14.25v6.375H4.875V12.75Z" fill="currentColor"/></svg>`
};
